import { useQueryClient } from '@tanstack/react-query';
import { useTable } from 'src/components/table';
import { Order_By, useAdsQuery, useDeleteAdsMutation } from 'src/graphql';
import UseSearch from 'src/hooks/use-search';
import { useLocales } from 'src/locales';

const useAds = () => {
  const table = useTable({ defaultRowsPerPage: 10, defaultCurrentPage: 0 });
  const queryClient = useQueryClient();
  const { t } = useLocales();

  const { methods, query, handleSearch, setQuery } = UseSearch<{
    sortBy: string;
    sortDirection: Order_By.Asc | Order_By.Desc | undefined;
    status: string | undefined;
    createdAt: {
      operator: '_lt' | '_gt';
      value: string;
    };
  }>();

  // #region Services
  const { data, isLoading } = useAdsQuery({
    offset: table.offset,
    limit: table.rowsPerPage,
  });

  const { mutate, isLoading: isDeleting } = useDeleteAdsMutation({
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['ADS'] }),
  });
  // #endregion Services

  // #region Handlers
  const handleDeleteADS = (id: string) => {
    mutate({ adsId: id });
  };
  // #endregion Handlers
  return {
    isDeleting,
    methods,
    t,
    handleDeleteADS,
    handleSearch,
    query,
    setQuery,
    isLoading,
    data,
    table,
  };
};

export default useAds;
